import React, { useEffect, useState } from 'react';
import '../App.css';
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from '../slices/index';
import * as User from '../slices/userSlice';
import * as Cases from '../slices/casesSlice';
import * as UI from '../slices/uiSlice';
import logo from '../assets/PLS_Primary_Logo_on_dark.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';

const Login = () => {
	const dispatch = useAppDispatch();
	let navigate = useNavigate();
	const userState = useAppSelector(state => state.user);
	const [pass, setPass] = useState('');
	const [loading, setLoading] = useState(false);
	const [invalid, setInvalid] = useState(false);

	const doLogin = async (user: string, pass: string) => {
		setInvalid(false);
		setLoading(true);
		dispatch(Cases.setLoaded(false));

		try {
			const rp = await dispatch(User.userLogin({ user: user, pass: pass })).unwrap();
			setLoading(false);
			if (rp.status !== 'OK') {
				dispatch(UI.setError({ visible: true, message: rp.status }));
				return;
			}
			if (rp.token !== '') {
				setPass('');
				if (rp.prevlogin === '0' || rp.force === '1') {
					dispatch(UI.setChangePasswordPopup(true));
				}
				dispatch(Cases.setUser(rp.refer));
				navigate('/home');
			} else {
				setInvalid(true);
			}
		} catch (err) {
			setLoading(false);
			dispatch(UI.setError({ visible: true, message: typeof err === 'string' ? err : 'Login failed' }));
		}
	}

	const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		doLogin(userState.user, pass);
	}

	useEffect(() => {
		setLoading(false);
		if (userState.token) {
			navigate('/home');
		}
	}, []);

	return (
		<div className="Login" style={{ position: 'relative' }}>
			<img className="logoSide" src={logo} alt='PLS-Logo' />

			<div className="loginPane">
				<div className="row50">
					<form className="loginBox" onSubmit={handleSubmit}>
						<div style={{ fontSize: 40, fontFamily: 'OpenSans-Bold', marginBottom: 28 }}>Introducer Portal</div>
						<div className="row100">
							<label style={{ fontFamily: 'OpenSans-SemiBold', fontSize: 18, marginBottom: 8 }} className="row100" htmlFor="username">Username:</label>
						</div>
						<div className="row100">
							<input style={{ marginBottom: 8 }} className="row100 LoginBox" type="text" id="username" name="username" autoComplete='username' value={userState.user} onChange={e => dispatch(User.setUser(e.target.value))} />
						</div>
						<div className="row100">
							<label style={{ fontFamily: 'OpenSans-SemiBold', fontSize: 18, marginBottom: 8 }} className="row100" htmlFor="password">Password:</label>
						</div>
						<div className="row100" style={{ marginBottom: 24 }}>
							<input style={{ marginBottom: 8 }} className="row100 LoginBox" type="password" id="password" name="password" autoComplete='current-password' value={pass} onChange={e => setPass(e.target.value)} />
						</div>

						<div style={{ display: 'flex', justifyContent: 'end' }}>
							<button type='submit' className='buttonLogin' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }}>
								<div style={{ display: 'flex', alignItems: 'center' }}>
									<div style={{ width: 64 }}></div>
									<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Login</div>
								</div>

								<div style={{ width: 64, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
									{loading && <FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />}
								</div>
							</button>
						</div>

						{invalid && <div style={{ fontFamily: 'OpenSans-SemiBold' }}>Invalid login details</div>}
					</form>
				</div>
				<div className="row50">
				</div>
			</div>
			<div className='loginFooter'></div>
		</div>
	);
}

export default Login;